<template>
      <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <div class="main_home_content">
    <div class="container">
      <div class="row">
        <div class="col-md-10 offset-md-1 pt-5 pb-5">
          <!-- Login Tab Content -->
          <div class="home-content">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-7 col-lg-6">
                <h1 :style="{ marginTop: '20px' }">
                  Detailed Complaint Analysis & Diagnosis Workflow
                </h1>
                <h3 :style="{ marginTop: '20px' }">
                  Turning Patient Complaints into Comprehensive Care Plans
                </h3>
                <h5 :style="{ marginTop: '20px' }">
                  {{main_data}} Integrated Approach to Complaint
                  Analysis and Diagnosis
                </h5>
                <p :style="{ marginTop: '20px' }">
                  Every patient complaint is a piece of a larger puzzle that,
                  when solved, reveals the most effective treatment path.
                  {{main_data}} system for Detailed Complaint Analysis &
                  Diagnosis Workflow provides healthcare practitioners a
                  structured and data-driven approach to understanding patient
                  concerns, leading to precise diagnoses and targeted care.
                </p>
              </div>
              <div class="col-md-12 col-lg-5">
                <img
                  src="@/assets/img/Complaint.jpeg"
                  class="img-fluid"
                  alt="Doccure Login"
                />
              </div>
            </div>
          </div>
          <!-- /Login Tab Content -->
        </div>
      </div>
    </div>
    <!-- Key Feature Section -->
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <h2 class="first_section_heading pb-6 pt-6" align="center" style="margin-top: 50px;margin-bottom: 50px;">
          Key Features
        </h2>
        <b-card-group deck>
          <b-card
            border-variant="dark"
            header="Structured Complaint Logging"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Capture Every Concern</h4>
            <b-card-text
              >Log patient complaints in a structured manner, ensuring that
              every detail, no matter how minute, is recorded and available for
              analysis.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Advanced Analysis Tools"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Dive Deeper into Patient Concerns</h4>
            <b-card-text
              >Utilize advanced analytical tools to categorize, prioritize, and
              assess patient complaints, ensuring a thorough understanding
              before diagnosis.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Integrated Diagnosis Workflow"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Streamlined Path to Diagnosis</h4>
            <b-card-text
              >Transition seamlessly from complaint analysis to the diagnosis
              phase, ensuring that all relevant data darkrms the diagnostic
              process.</b-card-text
            >
          </b-card>
        </b-card-group>
        <b-card-group deck style="margin-top: 30px;margin-bottom: 40px;">
          <b-card
            border-variant="dark"
            header="Collaborative Tools"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Team-based Approach to Care</h4>
            <b-card-text
              >Share and discuss patient complaints and diagnostic results with
              your medical team, fostering a collaborative approach to patient
              care.</b-card-text
            >
          </b-card>
          <b-card
            border-variant="dark"
            header="Patient Feedback Loop"
            header-bg-variant="dark"
            header-text-variant="white"
          >
            <h4>Keep the Patient in the Loop</h4>
            <b-card-text
              >Engage patients in the analysis and diagnosis process, ensuring
              their feedback and perspectives are considered, leading to more
              personalized care.</b-card-text
            >
          </b-card>
          <b-card style="border: none;"> </b-card>
        </b-card-group>
      </div>
      <!-- Benefit Section -->
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <h3 style="text-align: center; padding-bottom: 20px; margin-top: 50px;margin-bottom: 50px;" >
            Redefining the Patient Diagnosis Experience
          </h3>
          <b-card-group deck>
            <b-card
              border-variant="dark"
              header="Precision"
              header-bg-variant="dark"
              header-text-variant="white"
            >
              <b-card-text
                >Ensure accurate diagnoses darkrmed by comprehensive complaint
                analysis.</b-card-text
              >
            </b-card>
            <b-card
              border-variant="dark"
              header=" Efficiency"
              header-bg-variant="dark"
              header-text-variant="white"
            >
              <b-card-text
                >Streamline the transition from patient complaints to actionable
                care plans.</b-card-text
              >
            </b-card>
            <b-card
              border-variant="dark"
              header="Collaboration"
              header-bg-variant="dark"
              header-text-variant="white"
            >
              <b-card-text
                >Foster a team-based approach to diagnosis and
                treatment.</b-card-text
              >
            </b-card>
          </b-card-group>
          <b-card-group deck style="margin-top: 30px;">
            <b-card
              border-variant="dark"
              header="Patient-Centric"
              header-bg-variant="dark"
              header-text-variant="white"
            >
              <b-card-text
                >Engage patients in their care, leading to better outcomes and
                satisfaction.</b-card-text
              >
            </b-card>
            <b-card style="border: none;"> </b-card>
            <b-card style="border: none;"> </b-card>
          </b-card-group>
          <!--Call Action Section -->
          <div class="mt-5"
            style="display: flex; justify-content: center; align-items: center;"
          >
            <div style="width: 500px; text-align: center;" >
              <b-card bg-variant="info" text-variant="white" title="" style="border:1px solid black">
                <b-card-text style="text-align: center;">
                  Elevate the standard of patient diagnosis with {{main_data}} Detailed Complaint Analysis & Diagnosis Workflow.
                  Register today and harness the power of structured data in
                  patient care!
                </b-card-text>
                <b-button
                  href="#"
                  variant="dark"
                  style="text-align: center;"
                >
                  Register Now
                </b-button>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <layout-footer></layout-footer>
    </div>
    </div>
  </template>
  <script>
  import config from "../../services/CommonApi";
  import axios from "axios";
  export default {
    data() {
      return {
        main_data: "",
        config: config,
      };
    },
    mounted() {
      this.get_practitioner_profile();
    },
    methods: {
  
      async get_practitioner_profile() {
        var domain = window.location.hostname;
  
        const formdata = {
          domain: window.location.hostname,
        };
        await axios
          .get(
            "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
            window.location.hostname
          )
          .then((res) => {
            this.showspinner = false;
            if (res.data.status_code == 200) {
              this.main_data = res.data.data[0].brand_name
            }
            if (res.data.status_code == 404) {
              if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
              }
              else if (window.location.hostname.startsWith("192.168")) {
              } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
              } else {
                window.location.href = String("https://physio.kneexpert.in");
              }
            }
            this.$swal.close();
          });
      },
  
    },
  }
  </script>


// WEBPACK FOOTER //
// src/components/kneexpert/DetailedComplainetAnalysis.vue